import { jsxs as g, jsx as a } from "react/jsx-runtime";
import { E as v, S as d } from "./icons.types-0722eef5.js";
function p({ title: c, titleId: i, size: l, width: t, height: s, extended: r = !1, ...n }) {
  const h = r ? v : d, o = l ? h[l] : t || h[r ? "s" : "l"], e = l ? h[l] : s || h[r ? "s" : "l"];
  return /* @__PURE__ */ g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 64 64",
      width: o,
      height: e,
      "aria-labelledby": i,
      ...n,
      children: [
        c ? /* @__PURE__ */ a("title", { id: i, children: c }) : null,
        /* @__PURE__ */ a("g", { clipPath: "url(#Charge_Fault_svg__a)", children: /* @__PURE__ */ a(
          "path",
          {
            fill: "currentColor",
            d: "M31.995 4.803A26.896 26.896 0 0 0 19.417 7.92a.41.41 0 0 0-.217.363v2.744c0 .386.267.532.598.335a23.757 23.757 0 0 1 12.197-3.359c13.611 0 24.611 11.395 23.958 25.146-.577 12.17-11.72 22.797-23.904 22.824C19.352 56 8.942 46.103 8.096 33.619l8.805-.016c.732 4.527 4.496 7.997 9.044 7.997h10.287c1.195 0 2.168-1.016 2.168-2.26V24.682c0-1.246-.973-2.26-2.168-2.26H25.945c-4.54 0-8.3 3.46-9.041 7.979H5.6a.8.8 0 0 0-.8.8l.027 1.08.074 1.345c.921 15.333 14.568 27.29 30.507 25.338 12.571-1.54 22.197-11.283 23.6-23.869C60.835 18.722 48.01 4.803 31.995 4.803ZM41.6 37.6a.8.8 0 0 0 .8.8h8a.8.8 0 0 0 .8-.8V36a.8.8 0 0 0-.8-.8h-8a.8.8 0 0 0-.8.8v1.6Zm.8-8.8h8a.8.8 0 0 0 .8-.8v-1.6a.8.8 0 0 0-.8-.8h-8a.8.8 0 0 0-.8.8V28a.8.8 0 0 0 .8.8ZM11.232 17.92h2.312c.272-3.264.816-12.376.816-14.96V1.6h-4.08v1.36c0 2.584.68 11.696.952 14.96ZM9.6 23.36a2.72 2.72 0 1 0 5.44 0 2.72 2.72 0 0 0-5.44 0Z"
          }
        ) }),
        /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "Charge_Fault_svg__a", children: /* @__PURE__ */ a(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h64v64H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as ChargeFault
};
